import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import useNavigation from "~hooks/useNavigation"
import { StartFlex, CenterFlex, Text, Button } from "~components/El"
import { AuthLayout } from "~components/Layout"
import { useStores } from "~models"
import { globalToast } from "~utils"
import NewPassword from "../forget-password/components/new-password"
import ConfirmPassword from "../forget-password/components/confirm-password"
import { ResetPasswordScreenNavigationProps } from "./types"

const Fields = styled(StartFlex)`
  width: 100%;
  padding: 12px 20px;
  flex-direction: column;
`

const ResetPassword: React.FC<ResetPasswordScreenNavigationProps> = ({ route }) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { apiStore } = useStores()
  const params = route?.params

  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const onSubmit = async () => {
    if (!password) return globalToast.show("请输入新密码")
    if (password !== confirmPassword) return globalToast.show("两次输入的密码不一致")

    try {
      setLoading(true)
      await apiStore.updatePassword({ password: password, password2: confirmPassword, verify_token: params?.code })
      globalToast.show("密码已重置，请重新登录")
      navigation.navigate("Login")
    } catch (error) {
      globalToast.show(error?.message || "重置失败")
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout title="重置密码" subtitle="登录您的账户继续使用">
      <Fields>
        <NewPassword value={password} onChange={setPassword} />
        <ConfirmPassword value={confirmPassword} onChange={setConfirmPassword} />

        <CenterFlex width="100%" mt="10px">
          <Button
            width="100%"
            height="44px"
            borderRadius="8px"
            bg={theme.colors.primary}
            onClick={onSubmit}
            disabled={loading}
          >
            <Text color={theme.colors.textLight} fontSize={theme.fontSizes.lg} fontWeight="600">
              {loading ? "提交中..." : "确认重置"}
            </Text>
          </Button>
        </CenterFlex>
      </Fields>
    </AuthLayout>
  )
}

export default observer(ResetPassword)

